/**
 * HAWK SMART LOADER v4.0 (Dual Brand & White Theme)
 * - Arka plan bembeyaz (#ffffff)
 * - Üstte statik logo (Invert uygulanmış)
 * - Altında büyük "Kazanmak Daha Rahat" GIF'i
 * - Siyah ince progress bar ve simülasyon
 */

class HawkLoader {
    constructor() {
        this.injectStyles();
        this.createLoaderHTML();
        
        this.loaderEl = document.getElementById('hawk-smart-loader');
        this.barEl = document.getElementById('hawk-progress-fill');
        this.textEl = document.getElementById('hawk-loader-text');
        this.subTextEl = document.getElementById('hawk-loader-subtext');
        
        this.simulationInterval = null;
        this.currentProgress = 0;
        
        // Eski loading ekranını temizle
        const oldLoading = document.getElementById('loadingson');
        if(oldLoading) oldLoading.style.display = 'none';
        
    }

    show(initialText = "Sistem Hazırlanıyor...") {
        if(!this.loaderEl) return;
        
        this.resetProgress();
        clearInterval(this.simulationInterval);
        
        this.textEl.innerText = initialText;
        this.subTextEl.innerText = "Veriler analiz ediliyor...";
        
        this.loaderEl.style.display = 'flex';
        requestAnimationFrame(() => { this.loaderEl.style.opacity = '1'; });

        this.startSimulation();
    }

    hide() {
        if(!this.loaderEl) return;

        clearInterval(this.simulationInterval);
        this.updateProgress(100);
        this.updateMessage("İşlem Tamamlandı", "Sahne hazır.");

        setTimeout(() => {
            this.loaderEl.style.opacity = '0';
            setTimeout(() => {
                this.loaderEl.style.display = 'none';
                this.resetProgress();
            }, 500); 
        }, 800); 
    }

    startSimulation() {
        this.currentProgress = 0;
        // Simülasyon adımları
        const steps = [
            { limit: 30, text: "Koltuk iskeleti oluşturuluyor...", speed: 30 },
            { limit: 60, text: "Doku ve materyaller işleniyor...", speed: 50 },
            { limit: 85, text: "Işık ve gölge ayarları yapılıyor...", speed: 80 },
            { limit: 90, text: "Son rötuşlar...", speed: 150 } 
        ];

        let stepIndex = 0;

        this.simulationInterval = setInterval(() => {
            const step = steps[stepIndex];
            
            if (this.currentProgress < step.limit) {
                this.currentProgress += 1;
                this.updateProgress(this.currentProgress);
            } else {
                this.updateMessage(step.text);
                if (stepIndex < steps.length - 1) {
                    stepIndex++;
                }
            }
        }, 40); 
    }

    updateProgress(percent) {
        if(this.barEl) {
            this.barEl.style.width = `${percent}%`;
        }
    }

    updateMessage(text, subtext) {
        if(this.textEl) this.textEl.innerText = text;
        if(this.subTextEl && subtext) this.subTextEl.innerText = subtext;
    }

    resetProgress() {
        this.currentProgress = 0;
        if(this.barEl) this.barEl.style.width = '0%';
    }

    createLoaderHTML() {
        if(document.getElementById('hawk-smart-loader')) return;
        
        const div = document.createElement('div');
        div.id = 'hawk-smart-loader';
        // HTML YAPISI GÜNCELLENDİ: İki görsel alt alta
        div.innerHTML = `
            <div class="hawk-loader-content">
                <img src="/static/image/hawklogo512.png" class="hawk-static-logo" alt="Hawk Gaming Logo">
                
                <img src="/static/image/kazanmakdaharahat.gif" class="hawk-gif-logo" alt="Kazanmak Daha Rahat">
                
                <div class="hawk-progress-container">
                    <div id="hawk-progress-fill" class="hawk-progress-fill"></div>
                </div>
                
                <p id="hawk-loader-text" class="hawk-loader-text">Sistem Hazırlanıyor...</p>
                <p id="hawk-loader-subtext" class="hawk-loader-subtext">Lütfen bekleyin...</p>
                
                <div class="hawk-spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
            </div>
        `;
        document.body.appendChild(div);
    }

    injectStyles() {
        const style = document.createElement('style');
        style.textContent = `
            #hawk-smart-loader {
                position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                background: #ffffff; /* BEMBEYAZ ZEMİN */
                z-index: 9999999;
                display: flex; align-items: center; justify-content: center;
                opacity: 1; transition: opacity 0.5s ease;
                font-family: 'Poppins', sans-serif;
                color: #000; 
            }
            
            .hawk-loader-content { 
                text-align: center; 
                width: 85%; 
                max-width: 450px; 
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            /* --- GÖRSEL STİLLERİ --- */
            
            /* 1. Statik Logo (Üstteki) */
            .hawk-static-logo { 
                width: 100px; /* Daha zarif bir boyut */
                height: auto;
                
                filter: invert(1); /* Beyaz logoyu siyaha çevirir */
            }

            /* 2. GIF Logo (Alttaki) */
            .hawk-gif-logo {
                width: 150%; /* Büyük ve dikkat çekici */
                height: auto;
                margin-bottom: 3px;
                mix-blend-mode: multiply; /* Beyaz zeminde temiz kenarlar */
            }
            
            /* --- BAR VE METİN STİLLERİ --- */
            .hawk-progress-container {
                width: 50%; 
                height: 4px; /* İnce bar */
                background: #f0f0f0; 
                border-radius: 4px; 
                overflow: hidden; 
                margin-bottom: 20px;
                position: relative;
            }
            
            .hawk-progress-fill {
                height: 100%; width: 0%; 
                background: #000000; /* SİYAH RENK */
                transition: width 0.3s linear; 
            }
            
            .hawk-loader-text { 
                font-size: 15px; 
                font-weight: 600; 
                margin: 0; 
                color: #111; 
                text-transform: uppercase;
                letter-spacing: 1px;
            }
            
            .hawk-loader-subtext { 
                font-size: 12px; 
                color: #888; 
                margin-top: 8px; 
                font-weight: 400;
            }

            .hawk-spinner { margin-top: 20px; text-align: center; opacity: 0.5; }
            .hawk-spinner > div {
                width: 6px; height: 6px; 
                background-color: #000; 
                border-radius: 100%; display: inline-block;
                animation: hawk-bouncedelay 1.4s infinite ease-in-out both;
                margin: 0 3px;
            }
            .hawk-spinner .bounce1 { animation-delay: -0.32s; }
            .hawk-spinner .bounce2 { animation-delay: -0.16s; }
            @keyframes hawk-bouncedelay {
                0%, 80%, 100% { transform: scale(0); }
                40% { transform: scale(1.0); }
            }
        `;
        document.head.appendChild(style);
    }
}

window.hawkLoader = new HawkLoader();